module.exports = __webpack_public_path__ + "static/img/face2.685308c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/preview_img/face2.jpeg
// module id = MmC1
// module chunks = 0